import { render } from "./Herosection.vue?vue&type=template&id=47555e38&scoped=true"
import script from "./Herosection.vue?vue&type=script&lang=js"
export * from "./Herosection.vue?vue&type=script&lang=js"

import "./Herosection.vue?vue&type=style&index=0&id=47555e38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47555e38"]])

export default __exports__